import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../service/admin.service';
import { CommonService } from '../service/common.service';
import { ToastrService } from 'ngx-toastr';
import { DdlModel } from '../model/ddl.model';
import { ADMIN_TOKEN, routingPermission } from '../constants/constant';
import { firstValueFrom } from 'rxjs';
import { StateService } from '../service/state.service';
import { PrivilegesMenu } from '../model/adminPrivilegesList.model';
// 214796825

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.less'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule]
})
export class AuthCallbackComponent implements OnInit {

  companyForm: FormGroup
  companyTypeDdl: DdlModel[] = []
  cityDdl: DdlModel[] = []
  isSaved: boolean = false;
  accessToken: string
  isApiLoading: boolean;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private adminService: AdminService, private stateService: StateService,
    private commonService: CommonService, private toastrService: ToastrService) { }

  ngOnInit() {
    this.stateService.shimmerLoader$.subscribe((res: boolean) => {
      this.isApiLoading = res
    })
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.accessToken = token
        this.getCompanyTypeDdl()
        this.getCityDdl()
      }
      else
        this.router.navigate(['/admin'])
      this.initializeForm()
    });
  }

  ngOnInit2() {
    window.addEventListener('message', (event) => {
      if (event.origin !== "http://localhost:62787") return; // ✅ security check

      const { idToken } = event.data;
      if (idToken) {
        console.log("Received token securely:", idToken);
        // Save in localStorage/sessionStorage
        localStorage.setItem("google_token", idToken);
      }
    });
  }

  initializeForm() {
    this.companyForm = this.fb.group({
      id: [this.accessToken],
      companyName: ['', [Validators.required]],
      companyTypeId: ['', [Validators.required]],
      companyType: ['Select Company Type'],
      cityId: ['', [Validators.required]],
      city: ['Select City'],
      postalCode: ['', [Validators.required]],
      address: ['', [Validators.required]],
      isDummyData: [true]
    })
  }

  onCompanyTypeChange(company: DdlModel) {
    this.companyForm.get('companyTypeId')?.setValue(company.id);
    this.companyForm.get('companyType')?.setValue(company.name);
  }

  onCityChange(city: DdlModel) {
    this.companyForm.get('cityId')?.setValue(city.id);
    this.companyForm.get('city')?.setValue(city.name);
  }


  submit() {
    this.isSaved = true
    if (this.companyForm.invalid)
      return

    this.stateService.shimmerLoaderUpdate(true)
    this.adminService.addCompanyForFreeTrial(this.companyForm.value).subscribe({
      next: (res: any) => {
        if (res.meta.status_code) {
          this.commonService.handleSuccessfulLogin(res);
        }
        else {
          this.stateService.shimmerLoaderUpdate(false)
          this.toastrService.error(res.meta.status_message);
        }
      },
      error: (err: any) => { this.stateService.shimmerLoaderUpdate(false) }
    })
  }

  getCompanyTypeDdl() {
    this.commonService.companyTypeDdl().subscribe({
      next: (res: any) => {
        if (res.meta.status_code) {
          this.companyTypeDdl = res.data;
        }
        else {
          this.companyTypeDdl = [];
          this.toastrService.error(res.meta.status_message);
        }
      },
      error: (err: any) => { }
    })
  }

  searchString: string
  searchSettimeout: any

  onCitySearch(event: Event) {
    if (this.searchSettimeout)
      clearTimeout(this.searchSettimeout);
    this.searchSettimeout = setTimeout(() => {
      this.searchString = (event.target as HTMLInputElement).value;
      this.getCityDdl()
    }, 500)
  }

  getCityDdl() {
    this.commonService.cityDdlGoogle(this.searchString).subscribe({
      next: (res: any) => {
        if (res.meta.status_code) {
          this.cityDdl = res.data;
        }
        else {
          this.cityDdl = [];
          this.toastrService.error(res.meta.status_message);
        }
      },
      error: (err: any) => { }
    })
  }
}
